type withTimeOutReturn = ReturnType<typeof setTimeout>

export function withTimeOut(
  delayedFn: () => void,
  delay: number
): withTimeOutReturn {
  return setTimeout(delayedFn, delay)
}
